/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/naming-convention */
// These are common HPS fields that are present some tables
// They can be added to UI models...

import { IFieldText, IFieldDate, IFieldPickerItems, IFieldPickerModel, IFieldNumberWhole } from "@/@types/models/model";

const svrha_registracije: IFieldPickerItems = {
  title: 'Oznaka pripadnosti HPS-u',
  source: 'svrha_registracije',
  ttoken: 'users.svrha_registracije',
  type: 'radio',
  items: {
    labels: ['users.svrhe_registracije.reg', 'users.svrhe_registracije.hps'],
    values: [10, 20],
  },
  validation: {
    required: true
  },
  translate: true
};

const hps_ime: IFieldText = {
  title: 'Ime',
  source: 'hps_ime',
  ttoken: 'users.first_name',
  type: 'text',
  readonly: true
}

const hps_prezime: IFieldText = {
  title: 'Prezime',
  source: 'hps_prezime',
  ttoken: 'users.last_name',
  type: 'text',
  readonly: true
}

const hps_email: IFieldText = {
  title: 'E-mail',
  source: 'hps_email',
  ttoken: 'users.email',
  type: 'text',
  readonly: true,
  width: 'full'
}

const hps_has_licenca: IFieldPickerItems = {
  title: 'HPS Imam li licencu?',
  source: 'hps_has_licenca',
  ttoken: 'users.hps_has_licenca',
  type: 'boolean',
  items: {
    labels: ['common.ne', 'common.da'],
    values: [false, true],
    default: false,
  },
  translate: true
};

const hps_licenca_do: IFieldDate = {
  title: 'HPS Licenca do',
  source: 'hps_licenca_do',
  ttoken: 'users.hps_licenca_do',
  type: 'date',
  sort: true,
};

const hps_broj_vodicke_znacke: IFieldText = {
  title: 'HPS Broj vodicke znacke',
  source: 'hps_broj_vodicke_znacke',
  ttoken: 'users.hps_broj_vodicke_znacke',
  type: 'text',
  sort: true,
  width: 'full'
};

const hps_plan_udruga_id: IFieldPickerModel = {
  title: 'HPS Planinarska udruga ID',
  source: 'hps_plan_udruga_id',
  ttoken: 'users.hps_plan_udruga',
  type: 'picker',
  subModel: {
    apiPath: 'hps/planinarske-udruge?type=1&need_for=picker',
    format: '{label}',
  }
};

const hps_plan_udruga_naziv: IFieldText = {
  title: 'HPS Planinarska udruga ID',
  source: 'hps_plan_udruga_naziv',
  ttoken: 'users.hps_plan_udruga',
  type: 'text',
  readonly: true,
  width: 'full'
};

const hps_plan_udruga_oib: IFieldText = {
  title: 'HPS Planinarska udruga OIB',
  source: 'hps_plan_udruga_oib',
  ttoken: 'users.hps_plan_oib',
  type: 'text',
  readonly: true
};

const hps_spv_id: IFieldPickerModel = {
  title: 'HPS Stanica planinarskih vodiča',
  source: 'hps_spv_id',
  ttoken: 'users.hps_spv',
  type: 'picker',
  subModel: {
    apiPath: 'hps/planinarske-udruge?type=3&need_for=picker',
    format: '{label}',
  }
};

const hps_spv_naziv: IFieldText = {
  title: 'HPS Stanica planinarskih vodiča',
  source: 'hps_spv_naziv',
  ttoken: 'users.hps_spv',
  type: 'text',
  readonly: true,
  width: 'full'
};

const hps_spv_oib: IFieldText = {
  title: 'HPS Stanica planinarskih vodiča OIB',
  source: 'hps_spv_oib',
  ttoken: 'users.hps_spv_oib',
  type: 'text',
  readonly: true
};

const hps_izleti_count: IFieldNumberWhole = {
  title: 'Broj HPS izleta',
  source: 'hps_izleti_count',
  ttoken: 'users.hps_izleti_count',
  type: 'wholenum',
  readonly: true,
  calculated: true
}

export const hpsFields = {
  svrha_registracije
  , hps_ime
  , hps_prezime
  , hps_email
  , hps_has_licenca
  , hps_licenca_do
  , hps_broj_vodicke_znacke
  , hps_plan_udruga_id
  , hps_plan_udruga_naziv
  , hps_spv_id
  , hps_spv_naziv
  , hps_izleti_count
  , hps_spv_oib
  , hps_plan_udruga_oib
}